import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { resizeCanvas } from 'src/app/sigpad/sigpad_util';
import SignaturePad from '../../sigpad/signature_pad';
import { updateCanvasSize } from '../image-edit-util';

export interface TextAreaResult {
  error?: string;
  hasError: boolean;
  type: number;
  text?: string;
  free_text?: string;
};

@Component({
  selector: 'app-text-area-edit',
  templateUrl: './text-area-edit.component.html',
})
export class TextAreaEditComponent {

  public static readonly TEXT_MODE = 1;

  public static readonly FREE_TEXT_MODE = 2;

  signPad: SignaturePad | null = null;

  _commentType = 1;
  @Input('comment-type') set commentType(type:number) {
    this._commentType = type;
  }

  private _damageNoteText?: ElementRef;
  @ViewChild('noteText') set noteText(elem: ElementRef) {
    this._damageNoteText = elem;

    this.loadText();
  }

  private _canvasDamageNote?: ElementRef;
  @ViewChild('noteCanvas') set noteCanvas(elem: ElementRef) {
    this._canvasDamageNote = elem;

    this.signPad = updateCanvasSize(elem, this._canvasOptions);

    this.loadFreeText();
  }

  _blockStyle: any = {};
  @Input('block-style') set blockStyle(style: any) {
    this._blockStyle = style;
  }

  _canvasStyle: any = {};
  @Input('canvas-style') set canvasStyle(style: any) {
    this._canvasStyle = style;
  }

  _canvasOptions: any = {};
  @Input('canvas-options') set canvasOptions(options: any) {
    this._canvasOptions = options;

    if (this._canvasDamageNote) {
      this.signPad = updateCanvasSize(
        this._canvasDamageNote,
        this._canvasOptions
      );

      this.loadFreeText();
    }
  }

  _cleanBtnStyle: any = 'clear-button-default-style';
  @Input('clear-btn-style') set cleanBtnStyle(style: any) {
    this._cleanBtnStyle = style;
  }

  _freeTextData: any = '';
  @Input('free-text') set freeText(data: any) {
    this._freeTextData = data;
    this.loadFreeText();
  }

  _textData: any = '';
  @Input('text') set text(data: any) {
    this._textData = data;
    this.loadFreeText();
  }

  _switchStyle: any = '';
  @Input('switch-style') set switchStyle(style: any) {
    this._switchStyle = style;
  }

  _name: any = '';
  @Input('name') set name(name: any) {
    this._name = name;
  }

  _cols: any = 5;
  @Input('cols') set cols(rows: any) {
    this._cols = rows;
  }

  _rows: any = 5;
  @Input('rows') set rows(rows: any) {
    this._rows = rows;
  }

  _maxLength: any = 100;
  @Input('maxlength') set maxLength(maxLength: any) {
    this._maxLength = maxLength;
  }

  @Output('clear') clearEvent = new EventEmitter();

  clearClick() {
    this.clearEvent.emit(this._name);
  }

  clear() {
    const pad = this.signPad;
    if (pad) {
      pad.clear();
    }
  }

  changeCommentType(type: number) {
    this._commentType = type;
  }

  loadFreeText() {
    const pad = this.signPad;
    if (pad && this._freeTextData) {
      pad.fromDataURL(this._freeTextData);
    }
  }

  loadText() {
    const el = this._damageNoteText?.nativeElement;
    if (el) {
      el.value = this._textData;
    }
  }

  resizeCanvas() {
    resizeCanvas(this._canvasDamageNote, this.signPad);
  }

  /*
  toDataURL(): string | null {
    const pad = this.signPad;

    if (pad) {
      return pad.isEmpty() ? '' : pad.toDataURL();
    }
    return null;
  }
  */

  getDamageText(): TextAreaResult {
    const res: TextAreaResult = {
      hasError: true,
      type: this._commentType,
      text:'',
      free_text:''
    };

    if (this._commentType === 1) {
      const ref = this._damageNoteText?.nativeElement;
      if (ref) {
        let text = ref.value || '';
        text = text.trim();

        if (text.length) {
          res.text = text;
        }
        res.hasError = false;
      }
    } else {
      let p = this.signPad;
      res.free_text = '';

      if (p) {
        if (!p.isEmpty()) {
          res.free_text = p.toDataURL();
        }
        res.hasError = false;
      }
    }
    return res;
  }
}
